import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M100.65 242.47C100.65 255.754 109.024 263.84 120.865 263.84C132.416 263.84 141.08 255.754 141.08 242.47V88.5468C141.08 73.8187 132.416 64 118.554 64C109.313 64 101.516 67.7542 94.0076 72.9524L63.1075 94.3225C56.1766 98.9431 53 105.296 53 111.361C53 121.18 60.5084 128.399 69.7496 128.399C73.7926 128.399 78.1244 127.244 81.8786 124.645L100.072 112.227H100.65V242.47Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }